import BaseEntity from '../BaseEntity.model';

export default interface ISchedulerSettings extends BaseEntity {
    InterimCallAttemptHours: number;
}

export class SchedulerSettings implements ISchedulerSettings {
    Id: string;
    InterimCallAttemptHours: number;

    constructor() {
        this.Id = '';
        this.InterimCallAttemptHours = 4;
    }
}
